import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { addOnBookOptionWorkflow } from "src/routes/projects/change-events/guided/workflows/addOnBookOption/addOnBookOptionWorkflow";
import { applyFullConfigurationWorkflow } from "src/routes/projects/change-events/guided/workflows/applyConfiguration/full/applyFullConfigurationWorkflow";
import { applyPartialConfigurationWorkflow } from "src/routes/projects/change-events/guided/workflows/applyConfiguration/partial/applyPartialConfigurationWorkflow";
import { GuidedWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { swapProductInCatalogWorkflow } from "./swapProductCatalog/inCatalog/swapProductInCatalogWorkflow";
import { swapProductNotInCatalogWorkflow } from "./swapProductCatalog/notInCatalog/swapProductNotInCatalogWorkflow";

// Maps a change event workflow to the workflow that drives its steps. `GuidedWorkflow<any>`
// is the single, contained boundary where the per-workflow form shape is erased;
// each definition above keeps its concrete type, and the runner never inspects it.
export const guidedWorkflows: Record<ChangeEventWorkflow, GuidedWorkflow<any>> = {
  [ChangeEventWorkflow.ApplyFullConfiguration]: applyFullConfigurationWorkflow,
  [ChangeEventWorkflow.ApplyPartialConfiguration]: applyPartialConfigurationWorkflow,
  [ChangeEventWorkflow.AddOnBookOption]: addOnBookOptionWorkflow,
  [ChangeEventWorkflow.SwapProductInCatalog]: swapProductInCatalogWorkflow,
  [ChangeEventWorkflow.SwapProductNotInCatalog]: swapProductNotInCatalogWorkflow,
  // TODO: add the other workflows
  [ChangeEventWorkflow.ConfigurationTrueUp]: null as any,
  [ChangeEventWorkflow.FullLineCustomOption]: null as any,
};
